<div class="container py-2" style="background: #eeeeee;">
    <div class="row">
        <div class="col-xs-12 col-sm-10 d-flex align-items-center">
            <h1 class="align-middle">
                <span class="align-middle">{{season}} {{regionalName}} ({{regionalCode}})</span>
            </h1>
            
        </div>
        <div class="hidden-xs col-sm-2">
            <img class="d-none d-lg-block" [ngSrc]="seasonLogoPath" alt="Game Logo" width=175 height=60 style="max-width: 175px; max-height: 60px;"/>
        </div>
    </div>
</div>
<div class="container" *ngIf="eventStatus != 'Completed'">
    <div class="row">
        <div class="card">
          </div>
        <div class="card rounded-0">
            <div class="alert alert-success" role="alert" style="margin-top: 5px; margin-bottom: 5px; padding-bottom: 5px;">
                <i class="fa-regular fa-circle-info"></i>
                <p *ngIf="eventStatus == 'NotStarted'"><mat-icon aria-hidden="false" aria-label="info icon" fontIcon="info" style="vertical-align:middle"></mat-icon>&nbsp; Event has not yet started.</p>
                <p *ngIf="eventStatus == 'Started'"><mat-icon aria-hidden="false" aria-label="bolt icon" fontIcon="bolt" style="vertical-align:middle"></mat-icon>&nbsp;Event is in progress. Partial data will be displayed as point categories are finalized.</p>
              </div>
        </div>
</div>
</div>
<div class="container bg-white" style="padding-bottom: 0.75rem; padding-top: 0.75rem;">
    <div class="d-lg-none alert alert-warning alert-dismissible" role="alert">
        <h5 class="alert-heading">
            <i class="fas fa-mobile"></i> Small Screen!
        </h5>
        Some content is hidden on small displays like yours. Please try rotating your device or using a larger screen to
        see more content.
    </div>
    <div class="row">
        <div class="col-sm">
            <div id="mat-elevation-z8">
                <div class="responsive-table">
                <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows
                       class="mat-elevation-z8 table-responsive">
                    <!-- Rank Column -->
                    <ng-container matColumnDef="rank">
                        <th mat-header-cell *matHeaderCellDef> Rank</th>
                        <td mat-cell *matCellDef="let element"> {{ element.rank }}</td>
                    </ng-container>

                    <!-- Team Name Column -->
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef> <span class="d-none d-md-block text-center">Team</span> <span class="d-sm-block d-md-none">Team</span></th>
                        <td mat-cell *matCellDef="let element">
                            <div class="row text-sm-center">
                                <div class="col-4 d-none d-md-block">
                                    <img class="mt-1"
                                         *ngIf="getAvatar(element.teamNumber)"
                                         [src]="'data:image/png;base64,' + getAvatar(element.teamNumber)"
                                         width="40" height="40"/>
                                </div>
                                <div class="col-8 text-center text-md-start">
                                    <div class="fw-bold">
                                        <a
                                            href="https://frc-events.firstinspires.org/{{season}}/team/{{element.teamNumber}}">{{element.teamNumber}}</a>
                                    </div>
                                    <div class="d-none d-md-block"
                                        style="white-space: nowrap; text-overflow: ellipsis;">
                                        {{element.teamName}}</div>
                                    <div class="d-sm-block d-md-none"
                                        style="text-overflow: ellipsis;">
                                        {{element.teamName}}</div>
                                </div>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="qpp">
                        <th mat-header-cell *matHeaderCellDef> Qualification Round Performance</th>
                        <td mat-cell
                            *matCellDef="let element"> {{ element.regionalDetails.qualificationPerformancePoints != null ? element.regionalDetails.qualificationPerformancePoints : "-" }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="asp">
                        <th mat-header-cell *matHeaderCellDef> Alliance Selection</th>
                        <td mat-cell *matCellDef="let element"> {{ element.regionalDetails.allianceSelectionPoints != null ? element.regionalDetails.allianceSelectionPoints : "-" }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="pap">
                        <th mat-header-cell *matHeaderCellDef> Playoff Advancement</th>
                        <td mat-cell *matCellDef="let element"> {{ element.regionalDetails.playoffAdvancementPoints != null ? element.regionalDetails.playoffAdvancementPoints : "-" }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="ap">
                        <th mat-header-cell *matHeaderCellDef> Judged Team Awards</th>
                        <td mat-cell *matCellDef="let element"> {{ element.regionalDetails.awardPoints != null ? element.regionalDetails.awardPoints : "-" }}</td>
                    </ng-container>

                    <!-- Team Age Points Column -->
                    <ng-container matColumnDef="tap">
                        <th mat-header-cell *matHeaderCellDef> Team Age</th>
                        <td mat-cell *matCellDef="let element"> {{ element.regionalDetails.teamAgePoints != null ? element.regionalDetails.teamAgePoints : "-" }}</td>
                    </ng-container>

                    <!-- Event Points Column -->
                    <ng-container matColumnDef="total">
                        <th mat-header-cell *matHeaderCellDef> Total Event Points</th>
                        <td mat-cell *matCellDef="let element">
                            <strong> {{ element.regionalPoints != null ? element.regionalPoints : "-" }}</strong></td>
                    </ng-container>

                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef><i>FIRST</i> Championship</th>
                        <td mat-cell *matCellDef="let element">
                                <span class="badge bg-info"
                                      *ngIf="element.championshipStatus == 'Prequalified'">Pre-Qualified</span>
                            <a href="https://frc-events.firstinspires.org/{{season}}/{{element.qualifiedFirstCmpEventCode}}/awards"
                               target="_blank" class="badge bg-warning"
                               *ngIf="element.championshipStatus == 'QualifiedAtEventByAward' && element.qualifiedFirstCmpEventCode != ''"
                               style="text-decoration: none;">{{element.qualifiedFirstCmpAwardName}} at
                                {{element.qualifiedFirstCmpEventCode}}</a>
                            <span class="badge bg-success"
                                  *ngIf="element.championshipStatus == 'QualifiedFromRegionalPool' && element.qualifiedFirstCmpEventWeek != 0">Regional
                                    Pool
                                    Week {{element.qualifiedFirstCmpEventWeek}}</span>
                            <span class="badge bg-success"
                                  *ngIf="element.championshipStatus == 'QualifiedAtEventByRanking' && element.qualifiedFirstCmpEventCode != 0">Direct
                                    Qualified at {{element.qualifiedFirstCmpEventCode}}</span>
                            <span class="badge bg-secondary"
                                  *ngIf="element.declinedFirstCmp && element.declinedFirstCmpDate != null">Declined</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="expand">
                        <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button aria-label="expand row"
                                    (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">
                                @if (expandedElement === element) {
                                    <mat-icon>keyboard_arrow_up</mat-icon>
                                } @else {
                                    <mat-icon>keyboard_arrow_down</mat-icon>
                                }
                            </button>
                        </td>
                    </ng-container>

                    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                    <ng-container matColumnDef="expandedDetail">
                        <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
                            <div class="example-element-detail"
                                 [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                                <div style="width: 100%; margin: 5px;" *ngIf="element.tiebreakers != null">
                                    <ul class="list-group">
                                        <li class="list-group-item active"><strong>Tiebreaker details</strong></li>
                                        <li class="list-group-item">Max Playoff Advancement
                                            Points:<strong> {{ element.tiebreakers.EventPlayoffPoints }}</strong>
                                        </li>
                                        <li class="list-group-item">Max Alliance Selection
                                            Points:<strong> {{ element.tiebreakers.EventAlliancePoints }}</strong>
                                        </li>
                                        <li class="list-group-item">Max Qualification Performance
                                            Points:<strong> {{ element.tiebreakers.EventQualificationPoints }}</strong>
                                        </li>
                                        <li class="list-group-item">Highest Match Scores:
                                            <strong>{{ element.tiebreakers.MatchHighScore1 }}
                                                <span *ngIf="element.tiebreakers.MatchHighScore2 != null">,</span> {{ element.tiebreakers.MatchHighScore2 }}
                                                <span *ngIf="element.tiebreakers.MatchHighScore3 != null">,</span> {{ element.tiebreakers.MatchHighScore3 }}</strong></li>
                                    </ul>
                                </div>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand;sticky: true" style="font-weight: 700"></tr>
                    <tr mat-row *matRowDef="let element; columns: columnsToDisplayWithExpand;"
                        class="example-element-row"
                        [class.example-expanded-row]="expandedElement === element"
                        (click)="expandedElement = expandedElement === element ? null : element">
                    </tr>
                    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                </table>
                </div>
                <mat-paginator [pageSizeOptions]="[5, 10, 25, 50, 100]"
                               [pageSize]="25"
                               showFirstLastButtons
                               aria-label="Select page of periodic elements">
                </mat-paginator>
            </div>
        </div>
    </div>
</div>